import React, { ReactNode, useState } from 'react'

import { Prompts } from './Prompts'
import { PromptsContext } from './PromptsContext'
import { createPromptsStore } from './promptsStore'

export const IndependentPrompts = ({ children }: { children: ReactNode }) => {
  // the lazy initializer creates the store once and the setter is left unused
  // on purpose, so this component has no state update path and children never
  // re-render because of it
  const [store] = useState(createPromptsStore)

  return (
    <PromptsContext.Provider {...{ value: store }}>
      {children}
      <Prompts />
    </PromptsContext.Provider>
  )
}
